export default "__VITE_ASSET__ks01POlE__"